<div *ngIf="isShowing" class="popup-overlay" [style.z-index]="zIndex" (click)="cancel()">
    <div class="bg"></div>
    <div class="popup-container"
        [ngClass]="{'xsmall': popupType === popupTypes.XSMALL, 'small': popupType === popupTypes.SMALL, 'medium': popupType === popupTypes.MEDIUM, 'large': popupType === popupTypes.LARGE, 'full': popupType === popupTypes.FULL }">
        <div class="popup" (click)="suppress($event)">
            <h1 class="title">{{title}} <i class="mdi mdi-close close" (click)="cancel()"></i></h1>
            <div class="row">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>